import { SIZE_SM } from '@/constants/button-classes';

// Shared form-field styles (input / select / label). They reuse the buttons'
// SIZE_SM token so fields match the buttons' font/height/padding; only the
// field-specific bits (left-aligned text, background) differ.
const FIELD_BASE = `${SIZE_SM} w-full rounded-[10px] border border-white/10 font-bold text-[#f4f6f7] outline-none transition focus:border-[rgba(156,255,46,0.45)] focus-visible:ring-2 focus-visible:ring-[var(--np-green)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--np-bg-1)]`;

export const FIELD_INPUT = `${FIELD_BASE} bg-black/20 placeholder:font-normal placeholder:uppercase placeholder:text-[#f4f6f7a6]`;
export const FIELD_SELECT = `${FIELD_BASE} bg-white/[0.035] [color-scheme:dark]`;
export const FIELD_LABEL = 'text-[10px] font-black uppercase tracking-[0.16em] text-[#f4f6f7]';

// Loading spinner inside a button. The fixed 20px box matches the `leading-5` text
// line box the buttons use, so swapping the label for the spinner keeps the same height.
export const BTN_SPINNER = 'flex h-5 animate-spin items-center justify-center opacity-80';

// Turnstile / reCAPTCHA render at a fixed ~304px width. Inside the auth modals the
// usable width on small phones is only ~248px, so the widget clips. Scale it down
// below `mobile-l` so it always fits.
export const CAPTCHA_WRAP = 'flex origin-top scale-[0.78] justify-center +:scale-[0.86] mobile-l:scale-100';
